import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runTargetareClasificare } from "@/api/endpoints/targetare";
import { queryKeys } from "@/lib/queryClient";

export function useRunTargetareClasificare() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: runTargetareClasificare,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.all });
    },
  });
}
